// extracted by mini-css-extract-plugin
export var button = "_ax-0";
export var icon = "_ax-1";